import { useState } from "react";
import { AlertTriangle, Mail, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";

const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if no user, already verified, or dismissed, or social login (no email to verify)
  if (!user || dismissed) return null;
  
  const isEmailVerified = user.email_confirmed_at || user.confirmed_at;
  const isSocialLogin = user.app_metadata?.provider !== "email";
  
  if (isEmailVerified || isSocialLogin) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: "signup",
        email: user.email!,
        options: { emailRedirectTo: window.location.origin },
      });
      if (error) throw error;
      toast.success("מייל אימות נשלח מחדש!");
    } catch (err: any) {
      toast.error(err.message || "שגיאה בשליחת מייל אימות");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 text-amber-800 dark:text-amber-200 px-4 py-3 flex items-center gap-3 text-sm" dir="rtl">
      <AlertTriangle size={18} className="shrink-0" />
      <span className="flex-1">
        <strong>האימייל שלך לא אומת.</strong> חלק מהתכונות מוגבלות עד לאימות.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="gap-1.5 text-xs border-amber-500/50 hover:bg-amber-500/20"
        onClick={handleResend}
        disabled={sending}
      >
        <Mail size={14} />
        {sending ? "שולח..." : "שלח שוב"}
      </Button>
      <button onClick={() => setDismissed(true)} className="text-amber-600 hover:text-amber-800">
        <X size={16} />
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
